import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Form } from 'formik';

import pageWrapper from '../../containers/MainPage';
import Item from '../../../models/Item';
import { fetchCollections } from '../../../redux/ducks/collections';
import { fetchContacts } from '../../../redux/ducks/contacts';
import { deleteItem, updateItem } from '../../../redux/ducks/items';
import Loading from '../../common/Loading';
import Breadcrumbs from '../../common/Breadcrumbs';
import { getItemCategory } from '../../../config/constants';
import FormFeedback from '../../common/form/FormFeedback';
import { Attributes } from '../../../config/dataAttributesIndex';
import validationGenerator from '../../../validationGenerator';
import FormResult from '../../../FormResult';
import ItemTabs from './ItemTabs';
import { NotFound } from '../../NotFound';
import { categoryPluralize } from '../../common/itemTypePluralrize';
import './ItemPage.css';

class ItemPage extends Component {
  componentDidMount() {
    if (!this.props.collectionsFetched && !this.props.collectionsIsFetching) {
      this.props.getCollections();
    }

    if (!this.props.contactsFetched && !this.props.contactsIsFetching) {
      this.props.getContacts();
    }

    if (this.props.item) {
      this.props.onUpdateTitle(this.props.item.itemData.title);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.item && this.props.item !== prevProps.item) {
      this.props.onUpdateTitle(this.props.item.itemData.title);
    }
  }

  handleSubmit = (item, onSuccess, onFailure) => {
    const { onSubmit } = this.props;
    const successRedirect = () => {
      onSuccess();
    };
    onSubmit(item, successRedirect, onFailure);
  };

  handleDelete = (id) => {
    this.props.deleteItem(
      id,
      () => {
        this.props.history.push('/');
        this.props.getCollections();
      },
      () => {
        // eslint-disable-next-line no-alert
        alert('Failed to delete item.');
      }
    );
  };

  renderContents = (formProps) => {
    const { item } = this.props;
    const {
      // values,
      status,
      // handleSubmit, isSubmitting, touched,
    } = formProps;

    return (
      <Form>
        <FormFeedback status={status} />
        <ItemTabs item={item} formProps={formProps} onDelete={this.handleDelete} />
      </Form>
    );
  };

  render() {
    const {
      item, itemFetching, contactsFetched, collectionsFetched,
    } = this.props;

    if (!item && !itemFetching && collectionsFetched) {
      return <NotFound />;
    }

    if (!item || !contactsFetched) {
      return <Loading />;
    }

    const validationSchema = validationGenerator([
      ['itemData', Attributes.COMMON],
      ['specificData', Attributes[item.category]],
    ]);

    return (
      <div>
        <Breadcrumbs
          segments={[
            { label: 'Collections', linkTo: '/collections' },
            { label: categoryPluralize(item), linkTo: `/collections/${getItemCategory(item, true)}` },
            {
              label: item.getSubcategoryTypeAndKey()[1],
              linkTo: item.getPermalink().replace(/\/\d*$/, ''),
            },
            { label: item.itemData.title },
          ]}
        />

        <Formik
          initialValues={item}
          enableReinitialize
          onSubmit={(values, formikProps) => {
            const { setSubmitting, setStatus } = formikProps;
            const onSuccess = () => {
              setSubmitting(false);
            };
            const onFailure = (status) => {
              setSubmitting(false);
              setStatus(new FormResult(status));
            };

            this.props.onSubmit(values, onSuccess, onFailure);
          }}
          validationSchema={validationSchema}
          render={this.renderContents}
        />
      </div>
    );
  }
}

ItemPage.propTypes = {
  item: PropTypes.instanceOf(Item),
  contactsIsFetching: PropTypes.bool.isRequired,
  contactsFetched: PropTypes.oneOfType([PropTypes.bool, PropTypes.instanceOf(Date)]).isRequired,
  collectionsIsFetching: PropTypes.bool.isRequired,
  collectionsFetched: PropTypes.oneOfType([PropTypes.bool, PropTypes.instanceOf(Date)]).isRequired,
  itemFetching: PropTypes.bool.isRequired,
  getCollections: PropTypes.func.isRequired,
  getContacts: PropTypes.func.isRequired,
  deleteItem: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onUpdateTitle: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

ItemPage.defaultProps = {
  item: null,
};

function mapStateToProps(state, ownProps) {
  const givenId = parseInt(ownProps.match.params.itemId, 10);
  const { contacts, collections, items } = state;
  const { isFetching: contactsIsFetching, fetched: contactsFetched } = contacts;
  const { isFetching: collectionsIsFetching, fetched: collectionsFetched } = collections;
  const { isFetchingItem } = items;

  return {
    location: ownProps.match,
    item: state.collections.items.find(i => i.id === givenId),
    contactsIsFetching,
    contactsFetched,
    collectionsIsFetching,
    collectionsFetched,
    itemFetching: isFetchingItem,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getCollections: () => {
      dispatch(fetchCollections());
    },
    getContacts: () => {
      dispatch(fetchContacts());
    },
    deleteItem: (id, onSuccess, onFailure) => {
      dispatch(deleteItem(id, onSuccess, onFailure));
    },
    onSubmit: (item, onSuccess, onFailure) => {
      dispatch(updateItem(item, onSuccess, onFailure));
    },
  };
}

export default pageWrapper(connect(mapStateToProps, mapDispatchToProps)(ItemPage), 'Item');



// WEBPACK FOOTER //
// ./src/components/pages/collections/ItemPage.jsx